<template>
  <div class="providers-buttons">
    <CLink v-if="authProviderFactory.isEnabled(AuthProviders.GOOGLE)" @click="handleSocialLogin(AuthProviders.GOOGLE)">
      <CIcon class="mr-2" :src="require('@/assets/social_auth/icon-google.svg')" alt="Google Account"/>
      <span v-if="allowRegister" v-translate>Sign up with Google</span>
      <span v-translate v-else>Login with Google</span>
    </CLink>

    <CLink v-if="authProviderFactory.isEnabled(AuthProviders.FACEBOOK)" @click="handleSocialLogin(AuthProviders.FACEBOOK)">
      <CIcon class="mr-2" :src="require('@/assets/social_auth/icon-facebook.svg')" alt="Facebook Account"/>
      <span v-if="allowRegister" v-translate>Sign up with Facebook</span>
      <span v-translate v-else>Login with Facebook</span>
    </CLink>

    <CLink v-if="authProviderFactory.isEnabled(AuthProviders.APPLE)" @click="handleSocialLogin(AuthProviders.APPLE)">
      <CIcon class="mr-2" :src="require('@/assets/social_auth/icon-apple.svg')" alt="Apple Account"/>
      <span v-if="allowRegister" v-translate>Sign up with Apple</span>
      <span v-translate v-else>Login with Apple</span>
    </CLink>

    <CAlert color="danger" v-if="error">
      {{ error }}
    </CAlert>
  </div>
</template>

<script>
import {AuthProviders, SocialProviders} from "@/domain/login/constant/authProviders";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SocialLoginButtons',
  props: {
    allowRegister: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: null,
      loading: false,
      AuthProviders // Make constants available in template
    }
  },
  async mounted() {
    // Load SDKs for all enabled social providers
    const enabledSocial = this.authProviderFactory.getEnabled().filter(p => SocialProviders.includes(p))

    for (const providerName of enabledSocial) {
      const provider = this.authProviderFactory.getProvider(providerName)
      await provider.loadSDK()
    }
  },
  computed: {
    ...mapGetters('login', ['authProviderFactory', 'userLanguage'])
  },
  methods: {
    ...mapActions('login', ['authenticate']),

    async handleSocialLogin(providerName) {
      this.error = null

      try {
        this.loading = true

        const provider = this.authProviderFactory.getProvider(providerName)

        // Get token from SDK
        const token = await provider.startLogin()

        // Authenticate with backend
        await this.authenticate({
          method: providerName,
          credentials: {
            token,
            language: this.userLanguage,
            allowRegister: this.allowRegister
          },
          remember: true
        })

        this.$emit('login-success')
      } catch (e) {
        console.error(`${providerName} login error:`, e)
        this.error = this.$pgettext('login.error', 'Social login failed')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

